<template>
  <div
    class="pickers"
  >
    <input
      ref="datepicker"
      :class="`owal picker ${nativeDate ? 'native' : 'basic'} date`"
      type="date"
      :value="date"
      @change="dateChange"
      @blur="pickerBlur"
      @focus="pickerFocus"
    >
    <input
      ref="timepicker"
      :class="`owal picker ${nativeTime ? 'native' : 'basic'} time`"
      type="time"
      step="30"
      :value="time"
      @change="timeChange"
      @blur="pickerBlur"
      @focus="pickerFocus"
    >
  </div>
</template>

<script>
import moment from 'moment'
import * as nativeInputTag from '@/libraries/util/nativeInputCheck'

export default {
  name: 'DateTimePicker',
  props: {
    timestamp: {
      type: String,
    },
  },
  data () {
    return {
      timeFormat: 'HH:mm:ss',
      dateFormat: 'YYYY-MM-DD',
      timeout: null,
      nativeInputTag,
    }
  },
  computed: {
    date () {
      const date = moment(this.timestamp).format(this.dateFormat)
      return date
    },
    time () {
      const time = moment(this.timestamp).format(this.timeFormat)
      return time
    },
    nativeTime () {
      const supports = nativeInputTag.supportsTime()
      // console.debug(`Supports time: ${supports}`)
      return supports
    },
    nativeDate () {
      const supports = nativeInputTag.supportsDate()
      // console.debug(`Supports date: ${supports}`)
      return supports
    },
  },
  methods: {
    dateChange: function () {
      clearTimeout(this.timeout)
      const newDate = event.target.value
      const time = moment(this.timestamp).format(this.timeFormat)
      const timestamp = moment(`${newDate} ${time}`)
      this.timeout = setTimeout(function () {
        this.handleUpdate(timestamp)
      }.bind(this), 1000)
    },
    timeChange: function () {
      clearTimeout(this.timeout)
      const newTime = event.target.value
      const date = moment(this.timestamp).format(this.dateFormat)
      const timestamp = moment(`${date} ${newTime}`)
      this.timeout = setTimeout(function () {
        this.handleUpdate(timestamp)
      }.bind(this), 1000)
    },
    handleUpdate: function (timestamp) {
      clearTimeout(this.timeout)
      this.$emit('time-change', timestamp)
    },
    pickerBlur () {
      this.$emit('blur')
    },
    pickerFocus () {
      this.$emit('focus')
    },
  },
}
</script>
<style scoped>
.owal.picker {
  background: #F0F0F0;
  color: #475669;
  border: 1px solid #E0E0E0;
  border-radius: 5px;
  display: flex;
  font-family: 'Avenir-Medium';
  font-weight: bold;
  letter-spacing: 0;
  margin: 0 0.25rem;
  padding: 0.5rem 1rem;
  text-align: center;
  z-index: 1;
  transition: opacity 200ms ease, transform 200ms ease;
}

.owal.picker.basic {
  width: 9rem;
}

.owal.picker.native {
  display: flex;
  justify-content: center;
  overflow: visible;
  transition: width 200ms ease;
  box-sizing: border-box;
  cursor: pointer;
}

.owal.picker.native.date {
  width: 13.5rem;
}

.owal.picker.native.time {
  width: 12.5rem;
}

.owal.picker.native:hover {
  width: 14rem;
  transform: scale(1.05);
  opacity: 0.8;
}

.pickers {
  display: flex;
  flex-direction: row;
  width: auto;
  justify-content: space-around;
  padding: 0;
  margin: 0;
  height: 100%;
}

@media only screen and (min-width: 768px) {
  .owal.button {
      vertical-align: center;
      justify-content: center;
      align-items: center;
    }
}

@media only screen and (max-width: 414px) {
  .owal.button {
    vertical-align: center;
    justify-content: center;
    align-items: center;
    text-align: left;
  }
}

@media only screen and (min-width: 415px) and (max-width: 834px) {
  input {
    font-size: 12px !important;
  }
}

.labels {
  display: flex;
  flex-direction: row;
  width: auto;
  justify-content: space-around;
}

</style>
